import DataTable from "components/DataTable";
import React, { ReactNode } from "react";

interface Column {
  key: string;
  label: string;
  actions?: (row: Row) => React.ReactNode;
  excludeExport?: boolean;
}
interface Row {
  id: number;
  [key: string]: ReactNode;
}
interface DataTableProps {
  data: Row[];
  columns: Column[];
  itemsPerPage?: number;
  loading?: boolean;
  onAdd?: () => void;
  isInsertExcell?: boolean
  handleInsertClick?: () => void
}
const Employees: React.FC<DataTableProps> = ({
  data,
  columns,
  loading,
  onAdd,
  handleInsertClick,
  isInsertExcell
}) => {
  return (
    <DataTable
      data={data}
      columns={columns}
      title={"Employee Data"}
      loading={loading}
      onAddBtnClick={onAdd}
      isInsertExcel={isInsertExcell}
      handleInsertClick={handleInsertClick}
    />
  );
};
export default Employees;
